<!-- 多品类 -->
<template>
    <div class="practical-table" ref="scrollableDiv">
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="多品类卖场" name="salesroom">
                <saleroom></saleroom>
            </el-tab-pane>

            <el-tab-pane label="我的购买" name="mymultilebuy">
                <mybuyView :multiplecate="true"></mybuyView>
            </el-tab-pane>
        </el-tabs>
    </div>
    <FixedButtons @scroll-to-top="_scrollToTop" />
</template>
<script setup>
    import FixedButtons from "@/components/FixedButtons.vue";
    import { scrollToTop } from "@/utils/utils.js";
    import mybuyView from "@/views/details/mybuyView.vue";
    import { onMounted, ref } from "vue";
    import saleroom from "./components/saleroom.vue";

    /* ################################## */
    /*                tab栏                */
    /* ################################## */
    const activeName = ref("salesroom");
    const handleClick = (tab, event) => {};

    /* ################################## */
    /*                页面初始化               */
    /* ################################## */
    // const nowtabInit = () => {

    // };
    onMounted(() => {});
    // 需要暴露给父组件
    // defineExpose({
    //     nowtabInit,
    // });
    /* ################################## */
    /*                页面顶端            */
    /* ################################## */
    const scrollableDiv = ref(null);
    const _scrollToTop = () => {
        scrollToTop(scrollableDiv.value);
    };
</script>
<style scoped lang="scss">
    .practical-table {
        width: 100%;
        padding: 20px 40px;
        overflow: auto;
    }

    :deep(.el-tabs__item) {
        color: #ffffff;
    }

    :deep(.el-pagination > .is-first) {
        color: #ffffff;
    }

    :deep(.el-pagination__goto) {
        color: #ffffff;
    }

    :deep(.el-pagination__classifier) {
        color: #ffffff;
    }

    :deep(.el-pagination) {
        margin-top: 20px;
        display: flex;
        justify-content: center;
    }

    :deep(.el-table__header-wrapper th) {
        background-color: #6b6b6b !important;
        color: white !important;
    }
</style>
